import axios from 'axios';
import { MenuInterface } from 'restpay-api-lib/lib/@types/_interfaces/menus/menu.interface';
import { API_LINKS } from '../constants/links';

export const fetchRestaurantMenuDetails = (restaurantId: string): Promise<MenuInterface> =>
	axios.get(`${API_LINKS.FETCH_MENU_DETAILS}${restaurantId}`);
